var exports = {
  "k": "xa15a2ab7--54688f--container",
};

module.exports = exports;
